var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnreadBadge = function SvgUnreadBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_540_13657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 1,
    y: 1,
    fill: "#121212",
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 15C4.1339 15 1 11.8661 1 8C1 4.1339 4.1339 1 8 1C11.8661 1 15 4.1339 15 8C15 11.8661 11.8661 15 8 15ZM8.7 8V4.5H7.3V9.4H11.5V8H8.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_540_13657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    x: 1,
    y: 1,
    fill: "white",
    rx: 7
  })))));
};
export default SvgUnreadBadge;